import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heap-icon",
  "use": "icon-heap-icon-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-heap-icon\"><g><g><path d=\"M0,0L12,0L12,12L0,12L0,0ZM1.33333,1.33333L1.33325,10.667L10.6667,10.667L10.6667,1.33301L1.33333,1.33333Z\" fill-opacity=\"1\" /></g><g><path d=\"M0,4L0,5.5L12,5.5L12,4L0,4Z\" fill-opacity=\"1\" /></g><g transform=\"matrix(0,1,-1,0,9.5,-1.5)\"><path d=\"M5.5,5.5L13.5,5.5L13.5,4L5.5,4L5.5,5.5Z\" fill-opacity=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol